/**
 * @generated SignedSource<<7f68505f3c14e35a000b363ff879604e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type IntegrationNewsfeedProvider = "BOKAKLIPP" | "FALCON";
export type IntegrationNewsfeedScreenQuery$variables = {
  id: string;
};
export type IntegrationNewsfeedScreenQuery$data = {
  readonly store: {
    readonly integrationNewsfeed: {
      readonly id: string;
      readonly provider: IntegrationNewsfeedProvider;
    } | null;
  };
};
export type IntegrationNewsfeedScreenQuery = {
  response: IntegrationNewsfeedScreenQuery$data;
  variables: IntegrationNewsfeedScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "id"
    }
  ],
  "concreteType": "IntegrationNewsfeed",
  "kind": "LinkedField",
  "name": "integrationNewsfeed",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "provider",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IntegrationNewsfeedScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IntegrationNewsfeedScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0988dae73e3dc006af3eab56337f31a9",
    "id": null,
    "metadata": {},
    "name": "IntegrationNewsfeedScreenQuery",
    "operationKind": "query",
    "text": "query IntegrationNewsfeedScreenQuery(\n  $id: ID!\n) {\n  store {\n    integrationNewsfeed(id: $id) {\n      id\n      provider\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "922cae71c261c819343f6f224baeac15";

export default node;
